import React, { useState, useContext } from 'react';
import { AppContext } from '~/providers/AppProvider';
import { useRouter } from 'next/router';
import { defaultBoatSearchOptions, defaultFilterValues } from '~/api/config';
import { Counter, Button } from '@boatsetter-backup/js-component-lib';
import styled from 'styled-components';
import { Trans } from '@lingui/react';

const PassengersFilter = ({ setShowPassengersFilter }) => {
  const router = useRouter();
  const appCtx = useContext(AppContext);

  const [passengersCount, setPassengersCount] = useState(
    router.query.passengerCount === undefined ? defaultBoatSearchOptions.passengersCount : router.query.passengerCount
  );

  const pushPassengers = () => {
    setShowPassengersFilter(false);
    appCtx.actions.setLoading(true);

    const queryWithoutPageNum = router.query;
    delete queryWithoutPageNum.pageNumber;

    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...queryWithoutPageNum,
          passengerCount: passengersCount,
        },
      },
      undefined,
      { scroll: false }
    );
  };

  const clearPassengers = () => {
    setShowPassengersFilter(false);

    setPassengersCount(1);
    const currentQueries = router.query;

    delete currentQueries.passengerCount;
    delete currentQueries.pageNumber;

    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...currentQueries,
        },
      },
      undefined,
      { scroll: false }
    );
  };

  const changePassengersCount = (newCount) => {
    setPassengersCount(newCount);
  };

  return (
    <Wrapper>
      <FiltersWrapper>
        <Counter
          boatCapacity={defaultFilterValues.maxPassengers}
          buttonSize={40}
          minimum={defaultFilterValues.minPassengers}
          onClick={changePassengersCount}
          value={passengersCount}
        />
      </FiltersWrapper>

      <FilterBottomBar>
        <Clear onClick={clearPassengers}>
          {/* <Trans id="moreFilters.clearAll" /> */}
          Clear passengers
        </Clear>
        <Button small={true} onClick={pushPassengers} text={<Trans id="moreFilters.seeResults" />} />
      </FilterBottomBar>
    </Wrapper>
  );
};

const FiltersWrapper = styled.div`
  padding: 3em;

  button {
    background: transparent;
    outline: none;
    border: none;
  }
`;

const Wrapper = styled.div`
  width: 300px;
  height: auto;
  position: absolute;
  background-color: white;
  border: 1px solid #dbdfe5;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  top: 55px;

  @media (max-width: 960px) {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    width: 92%;
    overflow-x: hidden;
  }
`;

const FilterBottomBar = styled.div`
  height: 90px;
  width: 100%;
  position: sticky;
  bottom: 0;
  left: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 5px 22px -2px rgba(0, 0, 0, 0.2);
  padding: 2em;

  button span {
    font-size: 12px !important;
    font-family: AvenirNext, Avenir, Helvetica Neue, Helvetica, Arial, sans-serif;
  }
`;

const Clear = styled.div`
  font-size: 1em;
  line-height: 1.6;
  color: #0751c2;
  cursor: pointer;
`;

export default PassengersFilter;
